import { observable, action, makeObservable } from 'mobx';
import { InputType, ISelectValueType, ValueType } from './types';

export class AnyAssetInput implements InputType {
  dataType: string;

  label: string;

  placeholder?: string;

  tag: string;

  @observable selectorValue!: ValueType<ISelectValueType> | undefined;

  @observable
  value!: Record<string, any> | null;

  error: string;

  @observable disabled: boolean;

  required: boolean;

  route: string = '';

  isKey: boolean = false;

  isEdit: boolean = false;

  constructor({
    tag,
    label,
    placeholder,
    dataType,
    error,
    disabled,
    required,
    route = '',
    isKey = false,
    isEdit = false,
  }: InputType) {
    this.dataType = dataType;
    this.label = label;
    this.tag = tag;
    this.placeholder = placeholder;
    this.error = error;
    this.disabled = disabled;
    this.required = required;
    this.route = route;
    this.isKey = isKey;
    this.isEdit = isEdit;
    makeObservable(this);
    this.onChange(null); // set initial value
  }

  @action
  onChange = (v: ValueType<ISelectValueType> | null) => {
    this.selectorValue = v;

    if (v === null) {
      this.value = null;
    } else {
      this.value = { value: (v as ISelectValueType).value, label: (v as ISelectValueType).label };
    }
  };

  @action
  clearValue = () => {
    this.selectorValue = null;
    this.value = null;
  };

  @action
  toggleDisabled = () => {
    this.disabled = !this.disabled;
  };
}
